import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientService } from 'src/app/Service/client.service';
import { EventService } from 'src/app/Service/event.service';
import { AuthService } from 'src/app/Service/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-successful-manual-acceptance',
  templateUrl: './successful-manual-acceptance.component.html',
})
/**
 * Accept any user for successful manual
 */
export class SuccessfulManualAcceptanceComponent implements OnInit, OnDestroy {

  @ViewChild('successfulManualAcceptence', { static: true }) modalTemplateRef: TemplateRef<any>;
  
  @Input() idClient: number;
  @Output() displayChangeSuccessManual = new EventEmitter<any>();

  protected form: FormGroup;

  protected currentUser: any;
  protected userId: string = "";

  protected mdlSuccessfulManual: any;
  
  constructor (
    private readonly _modalService: NgbModal, 
    private readonly clientService: ClientService, 
    private readonly eventService: EventService, 
    private readonly authService: AuthService, 
    private readonly translateService: TranslateService, 
  ) {
    this.authService.currentUser.subscribe(resp => {
      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;
    });
    this.userId = this.currentUser.id;
  }

  public ngOnInit(): void {
    this.activateModal(this.modalTemplateRef);
    this.initForm();
    console.log("ID to manual validation: ", this.idClient);
  }

  public ngOnDestroy(): void {
      this.displayChangeSuccessManual.unsubscribe();
  }

  /**
   * Inititializes form for successful manual acceptance
   */
  private initForm(): void {
    this.form = new FormBuilder().group({
      txtReason: new FormControl('', Validators.compose([Validators.required])), 
    });
  }

  protected activateModal(modalTemplateRef: TemplateRef<any>): void {
    this.mdlSuccessfulManual = this._modalService.open(modalTemplateRef, { size: 'xl' });
  }

  /**
   * Method for execute the successful-manual-acceptance
   */
  protected onSubmit(): void {
    if(this.form.valid) {
      this.eventService.startLoadingData();
      this.clientService.confirmationClient(this.idClient.toString(), "EM", this.txtReason.value, this.userId).subscribe({
        next: (response: any) => {
          console.log(response);
          if(response === null) {
            this.eventService.successMessage(1);
            this.cancel();
          } else {
            let _error = response["error"];
            let _code = _error["code"];

            if (_code.length > 0 && _code == "OPERATION_FAILED") {
              console.log(_error["message"]);
              this.translateService.stream('server.response.' + _error["message"]).subscribe((res: string) => {
                this.eventService.errorMessage(3, res);
              });

            } else {
              this.eventService.errorMessage(2);
            }
          }
        },
        complete: () => { this.eventService.completeLoadingData(); },
        error: (msg) => { this.eventService.completeLoadingData(); 
          console.log(msg);
          this.translateService.stream('common.error500').subscribe((res: string) => {
            this.eventService.errorMessage(0, res);
          });
        }
      });

    } else {
      return Object.values(this.form.controls).forEach( control => {
        if( control instanceof FormGroup ){
          Object.values( control.controls).forEach( control => control.markAsTouched() );
        } else {
          control.markAsTouched();
        }
      });
    }
  }

  protected cancel(): void {
    this.mdlSuccessfulManual.close();
    this.displayChangeSuccessManual.emit(false);
  }

  protected get txtReason(): any { return this.form.get('txtReason'); }

}
